export const TankModel = (data) => {
    return {...data.item, sourceItems: data.deliveries}
};
